document.addEventListener('DOMContentLoaded', () => {
  const loadMoreButton = document.getElementById('load-more');
  const productsContainer = document.getElementById('product-grid');

  if (!loadMoreButton || !productsContainer) return;

  loadMoreButton.addEventListener('click', async () => {
    const nextPage = loadMoreButton.getAttribute('data-next-page');
    const totalPage = parseInt(loadMoreButton.getAttribute('total-pages'));
    if (!nextPage) return;

    try {
      const response = await fetch(`${window.location.pathname}?page=${nextPage}`);
      if (!response.ok) throw new Error('Failed to load more products.');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Extract new products and next page info
      const newProducts = doc.querySelector('#product-grid');
      const newNextPage = parseInt(nextPage) + 1;

      if (newProducts) {
        productsContainer.innerHTML += newProducts.innerHTML;
      }

      if (newNextPage > totalPage) {
        loadMoreButton.remove();
      } else {
        loadMoreButton.setAttribute('data-next-page', newNextPage);
      }
    } catch (error) {
      console.error('Error loading more products:', error);
    }
  });
});